<template>
  <div id="footer" class="container-fluid">
      <img src="https://yb-images.oss-cn-shenzhen.aliyuncs.com/Admin/2025/APRIL/18/17/7/b69bb968-a1f8-44a8-b258-50f43f047d71.png"  usemap="#planetmap" alt="Planets">
      <map name="planetmap" id="planetmap">

        <area shape="rect" coords="348,99,464,124" href="#"  @click="toPage(1)"/>
        <area shape="rect" coords="359,139,503,174" href="#"  @click="toPage(2)"/>
        <area shape="rect" coords="360,183,464,215" href="#"  @click="toPage(3)"/>

        <area shape="rect" coords="593,98,649,125" href="#"  @click="toPage(4)"/>
        <area shape="rect" coords="595,143,656,169" href="#"  @click="toPage(5)"/>
        <area shape="rect" coords="584,187,663,213" href="#"  @click="toPage(6)"/>
        <area shape="rect" coords="589,230,661,261" href="#"  @click="toPage(7)"/>

         <!-- <area target="" alt="" title="" href="" coords="348,99,464,124" shape="rect">
    <area target="" alt="" title="" href="" coords="359,139,503,174" shape="rect">
    <area target="" alt="" title="" href="" coords="360,183,464,215" shape="rect">
    <area target="" alt="" title="" href="" coords="593,98,649,125" shape="rect">
    <area target="" alt="" title="" href="" coords="595,143,656,169" shape="rect">
    <area target="" alt="" title="" href="" coords="584,187,663,213" shape="rect">
    <area target="" alt="" title="" href="" coords="589,230,661,261" shape="rect"> -->
       
</map>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
  methods: {
    toPage(page) {
     const routes = {
      1: { name: 'keygroups' },
      2: { name: 'hongKongBUD' },
      3: { name: 'highEnterpriseRecognition' },
      4: { name: 'about' },
      5: { name: 'successCases' },
      6: { name: 'contactUs' },
      7: { name: 'contactUs' }
    };
    
    if (routes[page]) {
      this.$router.push(routes[page]);
    } else {
      this.$router.push('/');
    }
    }
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}
@media screen and (max-width: 997px) {
  #footer img{
    width: 100%;
  }
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue